/**
 * Mapeo de jerarquías de áreas
 * 1 = GOBERNACION
 * 2 = MINISTERIO
 * 3 = SECRETARIA
 * 4 = SUBSECRETARIA
 * 5 = DIRECCION
 * 6 = DEPARTAMENTO
 */

export const JERARQUIA_MAP = {
    1: 'Gobernación',
    2: 'Laboratorio Central',
    3: 'Secretaría',
    4: 'Subsecretaría',
    5: 'Dirección',
    6: 'Departamento',
};

/**
 * Obtiene el nombre descriptivo de una jerarquía
 * @param {number} jerarquia - Número de jerarquía (1-6)
 * @returns {string} - Nombre descriptivo de la jerarquía
 */
export function getJerarquiaNombre(jerarquia) {
    if (!jerarquia || typeof jerarquia !== 'number') {
        return 'Desconocido';
    }
    return JERARQUIA_MAP[jerarquia] || `Nivel ${jerarquia}`;
}

/**
 * Obtiene la lista de jerarquías para usar en selects
 * @returns {Array} - Array de objetos con id y nombre
 */
export function getJerarquiasList() {
    return Object.keys(JERARQUIA_MAP).map(key => ({
        id: parseInt(key),
        nombre: JERARQUIA_MAP[key],
    }));
}

